import React,{useEffect,useRef} from 'react';
import { Select } from 'antd';
import 'antd/dist/antd.css';
import {getCountryMarketData} from '../services/chartdata'
import {percentOption,fillSeries} from '../utils/chartOptionConfig'

//按需加载
import echarts from 'echarts/lib/echarts'
//必需基础组件
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markPoint'
//导入矩形图
import 'echarts/lib/chart/bar'　
import 'echarts/lib/chart/line'　





export default function CountryMakret(props) {
	const { Option } = Select;

	const chartRef=useRef();
    let myChart=null;
    
	function renderMyChart(numType){
		numType=numType||2;
		getCountryMarketData().then((dt)=>{						
			
			let datalist=dt[0].dataList;			
			// console.log('datalist',datalist)
			// datalist=datalist[0].dataList;
			const chart=echarts.getInstanceByDom(chartRef.current)
			let myChart=null;
			if(chart){
				myChart=chart;
			}else{
				myChart=echarts.init(chartRef.current);
			}
			myChart.setOption(percentOption);

			let res=datalist.map(obj=>{
				let new_obj={};				
				for(let [k,v] of Object.entries(obj)){
					if(Array.isArray(v)){
						// new_obj[k]=v[numType];
						new_obj[k]=v[numType].toFixed(1);
					}else{
						new_obj[k]=v;
					}
				}
				return new_obj;
			})
			// console.log('res',res)	
			// let series=myChart.getOption().series;
			// let len=0;
			// if(res.length>0&&(len=Object.keys(res[0]).length)>3&&series.length<len){
			// 	for(let t=4;t<len;t++){
			// 		series.push({
			// 			type: 'bar',
			// 			stack:'占比',
			// 			 label: {
			// 					show: true,
			// 					fontSize: 10,
			// 					formatter: '{@['+t+']}%'
			// 				}
			// 		});
			// 	}
			// }
			// console.log('series',series);
			let series=fillSeries(7);

			myChart.setOption({
				series:series,
				title:{'text':'国别销售比例'},
				dataset:{
					source:res
				}
			});
		});
	}
	// 

	useEffect(()=>{
		// console.log("did.....")
		renderMyChart();
		return ()=>{
			// console.log("unmount...");
			myChart && myChart.dispose();
		}
	})
	return (
		<>
		<div>
            {/* ManRank
			<Select defaultValue="2" style={{ width: 100 }} onChange={handleChange}>				
				<Option value="2">批发</Option>				
				<Option value="3">零售</Option>				
			</Select> */}
			{/* <div style={{width: "1100px", height: "600px"}} ref={refObj['轿车']} />						
			<div style={{width: "1100px", height: "600px"}} ref={refObj['MPV']} />			
			<div style={{width: "1100px", height: "600px"}} ref={refObj['SUV']} />			 */}
			{/* <div style={{width: "1100px", height: "400px"}} ref={refObj['占比']} />			 */}
			<div style={{width: "1100px", height: "800px"}} ref={chartRef} />
		</div>

		</>
	);
}
